var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox-group',{attrs:{"options":_vm.options,"state":_vm.state,"disabled":_vm.disabled,"size":_vm.size,"stacked":""},on:{"input":_vm.handleInput},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }